import {
  Component,
  OnInit,
  Inject,
  Input,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { DOCUMENT } from "@angular/common";
import { AuthService } from "../auth/auth.service";
import { UserService } from "../core/services/v2/user.service";

@Component({
  selector: "app-user-home",
  templateUrl: "./user-home.component.html",
  styleUrls: ["./user-home.component.scss"],
})
export class UserHomeComponent implements OnInit {
  constructor(
    @Inject(DOCUMENT) private document,
    private router: Router,
    public authService: AuthService,
    private userService: UserService
  ) {}

  async ngOnInit() {
    const isLoggedIn = await this.authService.isLoggedIn();
    if (isLoggedIn) {
      this.RedirectAccorndilyUsersRole();
    } else {
      this.router.navigate(["home"]);
    }
  }

  private RedirectAccorndilyUsersRole() {
    this.userService.getUserDetails().subscribe(
      (res) => {
        if (res) {
          console.log("us", res);
          if (res.response && !res.response.isSuccess) {
            window.location.href = `/Session/SignOut`;
            return;
          }
          if (res.role == "AHIAdministrator") {
            this.router.navigate(["admin"]);
          } else if (res.role == "CaseManager" || (res.role =="Administrator" && res.healthOrganizationTypeId == 3)) {
            this.router.navigate(["casemanager"]);
          } else if (
            (res.isGlobalAdministrator ||
            this.userService.rolesRoutedToPhysician.indexOf(res.role) >= 0) && res.healthOrganizationTypeId == 1
          ) {
            // if (res.role == 'Physician' || res.role == 'Midlevel' || res.role == 'Front Desk' || res.role == 'Administrator'
            // || res.role == 'GlobalAdministrator')
            if (res.isProfileSetUpCompleted) {
              this.router.navigate(['physician']);
            } else {
              this.router.navigate(['physician/profile/setup']);
            }
            //this.router.navigate(["casemanager"]);
          } else if (res.role == "Patient") {
            this.router.navigate(["patient"]);
          }
          else if (res.role == "Employer") {
            this.router.navigate(["employer"]);
          }
          else if (res.role == "Call Care Coordinator") {
            this.router.navigate(["callcenter"]);
          }
          else if (res.role == "Employer Agent") {
            this.router.navigate(["agency"]);
          }
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }
}
